<template>
  <v-row
    align-center
    justify-center
    row
  >
    <v-col
      cols="12"
      md="3"
      lg="3"
      xl="3"
      class="px-0 ml-2"
    >
      <v-btn-toggle
        v-model="useExistingTaxi"
        class="px-0"
      >
        <v-btn
          small
          height="30"
          value="true"
          elevation="0"
        >
          <span class="cmr-label-text">Use Existing Taxi</span>
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <v-col
      class="px-0"
      cols="12"
      lg="6"
      xl="6"
      md="6"
    >
      <v-autocomplete
        v-model="taxi"
        :error-messages="errorForField()"
        :items="taxis"
        :loading="loading"
        :search-input.sync="search"
        item-text="registration_number"
        dense
        outlined
        placeholder="Search by registration or plate number"
        hide-no-data
        hide-selected
        no-filter
        return-object
        :disabled="!useExistingTaxi"
        @input="handleSelected"
      />
    </v-col>
  </v-row>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "ExistingTaxiV2",
  props: {
    errors: Object
  },
  data: function() {
    return {
      useExistingTaxi: false,
      taxi: {},
      loading: false,
      taxis: [],
      search: null
    };
  },
  watch: {
    search(query) {
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.taxis = res.data.taxis;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    useExistingTaxi() {
      if (this.useExistingTaxi == false) {
        this.taxi = {};
      }
      this.$emit("useExistingTaxiToggled", this.useExistingTaxi);
    }
  },
  methods: {
    handleSelected: function() {
      this.$emit("selectedTaxi", this.taxi);
    },
    errorForField: function() {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function() {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {}
    }
  }
};
</script>